import { Component } from 'react';

class DarkMode extends Component {
  componentDidMount(): null {
    const darkModeFlag = window.localStorage.getItem('sauceDarkMode');
    if (!darkModeFlag) {
      return null;
    }
    const htmlTag = document.querySelector('html');
    htmlTag?.classList.add('dark-mode');
    return null;
  }

  /*
    As of React 16, errors that were not caught by any error boundary will
    result in unmounting of the whole React component tree.
    Since it's just internal nice to have, it shouldn't affect UI at all.
  */
  componentDidCatch(): null {
    return null;
  }

  render(): null {
    return null;
  }
}

export { DarkMode };
